import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Label,
  FormGroup,
  Alert
} from "reactstrap";
import {
  getCustomer,
  resetCustomer,
  getCustomerSells,
  resetCustomerSells
} from "../../../../store/customer/actions";
import { formatHelper } from "../../../../common/helpers";
import { MainLoader, DataTable } from "../../../../components";
import MediaQuery from "react-responsive";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import * as columns from "./_columns";
import { layout } from "../../../../common/constants";
import moment from "moment";

class CustomerDetail extends Component {
  constructor(props) {
    super(props);
    const startDate = moment().startOf("month");
    const endDate = moment().endOf("month");

    this.state = {
      page: 1,
      startDate: startDate,
      endDate: endDate,
      focusedInput: null
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  async componentDidMount() {
    const { page, startDate, endDate } = this.state;
    await this.props.getCustomer(this.props.match.params.id);
    await this.props.getCustomerSells({
      page: page,
      startDate: startDate._d,
      endDate: endDate._d,
      id: this.props.match.params.id
    });
  }
  async componentWillUnmount() {
    await this.props.resetCustomerSells();
    await this.props.resetCustomer();
  }

  performGetSells() {
    const { page, startDate, endDate } = this.state;
    this.props.getCustomerSells({
      page: page,
      startDate: startDate._d,
      endDate: endDate._d,
      id: this.props.match.params.id
    });
  }

  async handleDateChange(startDate, endDate) {
    await this.setState({ startDate, endDate });
    if (startDate != null && endDate != null) {
      this.performGetSells();
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetSells();
  }

  renderField(label, value) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label color="red">{label}</Label>
        </Col>
        <Col xs="12" md="5">
          <p className="form-control-static">{value}</p>
        </Col>
      </FormGroup>
    );
  }

  renderFields() {
    const customer = this.props.customer;
    return (
      <div>
        {this.renderField("Nombre:", customer.name)}
        {this.renderField("Apellidos:", customer.lastname)}
        {this.renderField("DNI:", customer.dni)}
        {/* {this.renderField('Teléfono:', customer.cellphone)} */}
        {this.renderField("Email:", customer.email)}
        {this.renderField("Distrito:", customer.district)}
        {this.renderField("Género:", formatHelper.toGender(customer.gender))}
        {customer.birthday &&
          this.renderField(
            "Cumpleaños:",
            formatHelper.toDateDDMMYYY(customer.birthday)
          )}
        {!customer.birthday && customer.Approximate_age && customer.birthdate && (
          <div>
            {this.renderField(
              "Edad Aproximada:",
              customer.Approximate_age.value
            )}
            {this.renderField(
              "Cumpleaños: ",
              formatHelper.toDateDDMMYYY(customer.birthdate)
            )}
          </div>
        )}
        {this.renderField("Comentarios:", customer.comments)}
      </div>
    );
  }

  renderDataTable(columns, data, pageSize, total, loading) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={total}
        loading={loading}
        sizePerPage={pageSize}
        onPageChange={this.handlePageChange}
      />
    );
  }

  render() {
    const {
      customer,
      loading,
      error,
      sells,
      sellError,
      sellLoading,
      pageSize,
      total
    } = this.props;
    const { startDate, endDate } = this.state;

    if (error) {
      return <Alert color="danger">{error}</Alert>;
    }
    if (loading) {
      return <MainLoader />;
    } else if (!customer) return <div />;

    return (
      <div className="animated">
        <Card>
          <CardHeader>Detalle del Cliente</CardHeader>
          <CardBody>
            {this.renderFields()}
            <Row className="mb-3">
              <Col md="12">
                <DateRangePicker
                  startDate={startDate}
                  startDateId="startDate"
                  endDate={endDate}
                  endDateId="endDate"
                  displayFormat={"DD/MM/YYYY"}
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleDateChange(startDate, endDate)
                  }
                  focusedInput={this.state.focusedInput}
                  onFocusChange={focusedInput =>
                    this.setState({ focusedInput })
                  }
                  startDatePlaceholderText="Fecha Inicio"
                  endDatePlaceholderText="Fecha Fin"
                  small
                  isOutsideRange={() => false}
                  hideKeyboardShortcutsPanel
                />
              </Col>
            </Row>
            {sellError ? (
              <Alert color="danger">{sellError}</Alert>
            ) : !sellLoading ? (
              <Row>
                <Col>
                  <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                    {this.renderDataTable(
                      columns.customerDetailXS(),
                      sells,
                      pageSize,
                      total,
                      sellLoading
                    )}
                  </MediaQuery>
                  <MediaQuery
                    minWidth={layout.SM_MIN_WIDTH}
                    maxWidth={layout.SM_MAX_WIDTH}
                  >
                    {this.renderDataTable(
                      columns.customerDetailSM(),
                      sells,
                      pageSize,
                      total,
                      sellLoading
                    )}
                  </MediaQuery>
                  <MediaQuery
                    minWidth={layout.MD_MIN_WIDTH}
                    maxWidth={layout.LG_MAX_WIDTH}
                  >
                    {this.renderDataTable(
                      columns.customerDetailMD(),
                      sells,
                      pageSize,
                      total,
                      sellLoading
                    )}
                  </MediaQuery>
                  <MediaQuery minWidth={layout.XL_MIN_WIDTH}>
                    {this.renderDataTable(
                      columns.customerDetail(),
                      sells,
                      pageSize,
                      total,
                      sellLoading
                    )}
                  </MediaQuery>
                </Col>
              </Row>
            ) : (
              <MainLoader />
            )}
            <Row>
              <Col className="mt-3">
                <Button
                  color="secondary"
                  onClick={() =>
                    this.props.history.push("/administration/customers")
                  }
                >
                  <i className="fa fa-chevron-left mr-1" /> Volver
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { customer, error, loading } = state.customer.activeCustomer;
  const {
    sells,
    error: sellError,
    loading: sellLoading,
    pageSize,
    total
  } = state.customer.customerSellList;
  return {
    customer,
    error,
    loading,
    sells,
    sellError,
    sellLoading,
    pageSize,
    total
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCustomer,
      resetCustomer,
      getCustomerSells,
      resetCustomerSells
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerDetail);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Customer/CustomerDetail/CustomerDetail.js